import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  type SelectChangeEvent,
} from "@mui/material";

const LOOKBACK_OPTIONS = [
  { value: 12, label: "1 year" },
  { value: 24, label: "2 years" },
  { value: 30, label: "2.5 years" },
  { value: 36, label: "3 years" },
  { value: 48, label: "4 years" },
  { value: 60, label: "5 years" },
  { value: "ALLTIME", label: "All Time" },
] as const;

interface Props {
  value: number | string;
  onChange: (value: number | string) => void;
  disabled?: boolean;
  label?: string;
}

export function LookbackSelector({
  value,
  onChange,
  disabled,
  label = "Lookback Period",
}: Props) {
  const handleChange = (e: SelectChangeEvent<number | string>) => {
    const raw = e.target.value;
    onChange(raw === "ALLTIME" ? raw : Number(raw));
  };

  return (
    <FormControl size="small" sx={{ minWidth: 180 }} disabled={disabled}>
      <InputLabel id="lookback-selector-label">{label}</InputLabel>
      <Select
        labelId="lookback-selector-label"
        value={value}
        label={label}
        onChange={handleChange}
        data-testid="lookback-selector"
      >
        {LOOKBACK_OPTIONS.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
